export const capitalize = (str) => {
  if (typeof str !== "string") {
    return ""
  }
  
  if (str === "USA" || str === "США" || str === "UAE" || str === "ОАЭ") {
    return str;
  }
  
  const strAsArr = str.split(" ");
  
  if (strAsArr?.length > 1) {
    return strAsArr.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ")
  }
  
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
